export default {
  computed: {
    getActiveLetter() {
      return this.$route.query.letter;
    }
  }
};
